/** This represents the parameters of the Excel file "Infostelle_Bewertungstool_V5.xlsm"
 * Clustered into the three sections
 */

export const travelTimeParameters = {
  occupany_rate_parking: 0.9,
  pupils_rate: 0.14,
  adults_rate: 0.86,
  travel_days_adults: 300,
  travel_days_pupils: 250,
  occupany_rate_people_car: 1.3,
  travel_duration_average_minutes: 30,
  terminal_latency: 6,
  travel_duration_change_car: 0.9,
  travel_duration_change_parkandride: 0.9,
  travel_duration_change_publictransport: 1.4,
  travel_duration_change_bike: 1.4,
  cost_rate_usage_euro_per_hour: 7.1,
};

export const mileageParameters = {
  municipipality_rate: 0.5,
  pedelec_rate: 0.1,
  pedelec_bike_ratio: 6.1 / 3.7,

  co2_emission_pedelec_per_km: 4.14,
  co2_emission_car_per_km: 127,

  bike_costs_per_km: 0.076,
  pedelec_costs_per_km: 0.126,
  car_costs_per_km: 0.22,

  air_pollutant_costs_pedelec: 0.009,
  air_pollutant_costs_car: 0.4,

  accident_costs_bike_per_km: 0.243,
  accident_costs_pedelec_per_km: 0.243,
  accident_costs_car_per_km: 0.085,

  co2_per_tons: 670,
};

export const healtcare_parameters = {
  health_effect_per_person_cost: 320.16,
  reduced_mortality_cost_per_km: 0.036,
};
